export const reduceReadOrganizationsByUserRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingOrganizations: true },
  };
};

export const reduceReadOrganizationsByUserSuccess = (
  state,
  { payload: { organizationsByUser } },
) => {
  return {
    ...state,
    base: { ...state.base, allIDs: [...organizationsByUser] },
    ui: { ...state.ui, isFetchingOrganizations: false },
  };
};

export const reduceReadOrganizationsByUserFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingOrganizations: false },
  };
};
